import { ThemeProvider } from "styled-components";
import theme from "./theme";
import RoutesApp from "./routes";
import { BrowserRouter } from "react-router-dom";
import ReactPixel from 'react-facebook-pixel';
import { useEffect } from "react";
import { useLoginStore } from "./zustand/StoreAuth/store";
import { PrimeReactProvider } from 'primereact/api';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next'; // Certifique-se de importar o i18n
import { translations } from "./data/translateFixo";

export default function App() {
  const { userInfo } = useLoginStore();
  const languageTag = navigator.language.split('-')[0];
  // console.log(languageTag)

  i18n
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: translations.en },
        pt: { translation: translations.pt },
        es: { translation: translations.es },
      },
      lng: languageTag,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });

  useEffect(() => {
    const advancedMatching = { em: userInfo?.email } as any;
    const options = {
      autoConfig: true, // ativa a configuração automática do pixel
      debug: false, // desativa os logs
    };

    ReactPixel.init('302407215895946', advancedMatching, options);
    ReactPixel.pageView(); // Rastreia a visualização da página
    // Se precisar rastrear eventos adicionais, faça isso aqui
    // ReactPixel.track('TrackEventName', data);
    // ReactPixel.trackSingle('PixelId', 'TrackEventName', data);
  }, []);

  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <RoutesApp />
        </ThemeProvider>
      </BrowserRouter>
    </PrimeReactProvider>
  );
}